import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import { Redirect, useParams } from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import myToast from "../Utils/MyToast";
import Iframe from "react-iframe";

import MdlStudentIdCardSettings from "../dialog/MdlStudentIdCardSettings";
import MdlSelectMultipleStaff from "../dialog/MdlSelectMultipleStaff";
import MdlStaffIdCardSettings from "../dialog/MdlStaffIdCardSettings";

const PrintableDocsStaffId = () => {
  const [loggedIn, setLoggedIn] = useState(true);
  const [Loading, setLoading] = useState(false);
  const [isOpenSelectStaff, setIsOpenSelectStaff] = useState(false);
  const [isOpenSettings, setIsOpenSettings] = useState(false);

  const [Total, setTotal] = useState(0);
  const [mSelectedStaff, setMSelectedStaff] = useState([]);
  const [mPrintableSamples, setMPrintableSamples] = useState([]);
  const [mColorOption, setMColorOption] = useState([]);
  const [iFrameHeight, setIFrameHeight] = useState("0px");
  const [SELECTED_SAMPLE_ID, setSelectedSampleId] = useState("");
  const [SELECTED_SAMPLE_POSITION, setSelectedSamplePosition] = useState(0);
  const [SELECTED_COLOR_POSITION, setSelectedColorPosition] = useState(0);
  const [SELECTION_TYPE, setSELECTION_TYPE] = useState("");
  const [FILE_URL, setFILE_URL] = useState("");
  const [FILE_NAME, setFILE_NAME] = useState("");
  const [FILE_DIRECTORY, setFILE_DIRECTORY] = useState("");
  const [DOCUMENT_TYPE, setDOCUMENT_TYPE] = useState("");
  const [COLOR_OPTION_ID, setCOLOR_OPTION_ID] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [preview, setPreview] = useState("1");
  const [PreviewURL, setPreviewURL] = useState("");

  const { document_type } = useParams();
  const [height, setHeight] = useState("800px");
  const iframeRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) setLoggedIn(false);
    setDOCUMENT_TYPE(document_type);
    getPrintableSamples();

    const handleMessage = (event) => {
      if (event.data && event.data.iframeHeight) {
        setHeight(`${event.data.iframeHeight}px`);
      }
    };
    window.addEventListener("message", handleMessage, false);
    return () => window.removeEventListener("message", handleMessage);
  }, [document_type]);

  useEffect(() => {
    setSELECTION_TYPE("student");
    createFileUrL();
  }, [mSelectedStaff]);

  useEffect(() => {
    if (mPrintableSamples.length > 0) {
      setSample(SELECTED_SAMPLE_POSITION, mPrintableSamples);
    }
  }, [mPrintableSamples]);

  useEffect(() => {
    if (mPrintableSamples.length > 0 && SELECTED_SAMPLE_POSITION !== null) {
      getColorOptions(SELECTED_SAMPLE_POSITION, mPrintableSamples);
    }
  }, [SELECTED_SAMPLE_POSITION, mPrintableSamples]);

  useEffect(() => {
    if (mSelectedStaff.length > 0) createFileUrL();
  }, [SELECTED_COLOR_POSITION, mColorOption]);

  const getPrintableSamples = () => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getPrintableSample.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;
    const params = {
      school_code: SCHOOL_CODE,
      document_type: document_type,
    };

    const queryString = new URLSearchParams(params).toString();
    console.log("Full URL: ", `${URL}${queryString}`);

    axios
      .get(URL, {
        params: params,
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          setMPrintableSamples(response.data);
          //setSample(SELECTED_SAMPLE_POSITION, response.data);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("error>>>>>", error);
      });
  };

  const setSample = (position, samples = mPrintableSamples) => {
    const sample = samples[position];

    // console.log("file_name:", sample.file_name);
    // console.log("file_directory:", sample.file_directory);
    // console.log("sample_id:", sample.sample_id);

    setFILE_NAME(sample.file_name);
    setFILE_DIRECTORY(sample.file_directory);
    setSelectedSampleId(sample.sample_id);
    setSelectedSamplePosition(position);
  };

  const getColorOptions = (position, samples = mPrintableSamples) => {
    const options = samples[position].color_options || [];
    setMColorOption(options);
    setColorOptions(SELECTED_COLOR_POSITION, options);
  };

  const setColorOptions = (position, colorOptions = mColorOption) => {
    if (colorOptions.length === 0) {
      setCOLOR_OPTION_ID("");
    } else {
      setCOLOR_OPTION_ID(colorOptions[position].color_option_id);
    }
    setSelectedColorPosition(position);
  };

  const createFileUrL = () => {
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    let mStaffIds = [];
    let session_id = "";
    mStaffIds = mSelectedStaff.map((s) => s.staff_id);
    session_id = mSelectedStaff[0]?.session_id || "";

    const URL =
      process.env.REACT_APP_SERVER_NAME +
      FILE_DIRECTORY +
      FILE_NAME +
      `?&staff_ids=${JSON.stringify(
        mStaffIds
      )}&session_id=${session_id}&sample_id=${SELECTED_SAMPLE_ID}&system_code=${
        process.env.REACT_APP_SYSTEM_CODE
      }&color_option_id=${COLOR_OPTION_ID}&school_code=${SCHOOL_CODE}`;

    const URL_preview =
      process.env.REACT_APP_SERVER_NAME +
      FILE_DIRECTORY +
      FILE_NAME +
      `?&staff_ids=${JSON.stringify(
        mStaffIds
      )}&session_id=${session_id}&sample_id=${SELECTED_SAMPLE_ID}&system_code=${
        process.env.REACT_APP_SYSTEM_CODE
      }&color_option_id=${COLOR_OPTION_ID}&preview=${preview}&school_code=${SCHOOL_CODE}`;

    console.log("URL>>>", URL_preview);
    setFILE_URL(URL);
    setPreviewURL(URL_preview);
    setShowPreview(true);
  };

  const HandleSelectedStaff = (staff) => {
    setIsOpenSelectStaff(false);
    setMSelectedStaff(staff || []);
  };

  const changeSample = (index) => {
    setSample(index, mPrintableSamples);
  };

  const changeColor = (index) => {
    setColorOptions(index, mColorOption);
  };
  const HandleDone = () => {
    setIsOpenSettings(false);
    createFileUrL();
  };

  const OpenSettings = () => {
    //console.log("mSelectedStaff:", mSelectedStaff);
    if (!mSelectedStaff || mSelectedStaff.length === 0) {
      myToast.notify("Select Staff First");
    } else {
      setIsOpenSettings(true);
    }
  };

  if (!loggedIn) return <Redirect to="/Login" />;
  if (Loading) return <MyLoader />;

  return (
    <div className="content">
      <div
        className="content-header"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i className="fa fa-home" style={{ color: COLORS.white }} />
              <a href="#">
                {mPrintableSamples.length > 0
                  ? "Printable-" + mPrintableSamples[0].document_caption
                  : "Printable"}
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Selection Buttons */}
      <div
        className="animated fadeInUpn bg_page_white_rounded box_shadow"
        style={{ "--mMargin": "50px" }}
      >
        <div className="row">
          <div className="col-sm-6 padding_0">
            <div
              className="bg_card_primary_outline gravity_center_vertical"
              style={{ padding: "5px", color: "#fff" }}
            >
              <div
                className="bg_card_primary gravity_center width_match_parent margin_5 padding_5"
                onClick={() => setIsOpenSelectStaff(true)}
              >
                <h5 className="arrow">Select Staff</h5>
              </div>
            </div>
          </div>

          <div className="col-sm-6 padding_0">
            <div
              className="bg_card_primary_outline"
              style={{ padding: "5px", color: "#fff" }}
            >
              <div
                className="bg_card_primary gravity_center width_match_parent margin_5 padding_5"
                onClick={() => OpenSettings()}
              >
                <h5 className="arrow">IdCard Settings</h5>
              </div>
            </div>
          </div>
        </div>

        {/* Sample List */}
        <h5 className="margin_10">Sample List</h5>
        <div className="row bg_card_grey_outline" style={{ height: "140px" }}>
          {mPrintableSamples.map((item, index) => (
            <div className="col-sm-2 padding_0 height_match_parent" key={index}>
              <div
                className={
                  SELECTED_SAMPLE_POSITION === index
                    ? "bg_card_green_outline cursor"
                    : "bg_card_grey_outline cursor"
                }
                style={{
                  padding: "1px",
                  color: "#fff",
                  margin: "5px 10px",
                  height: "110px",
                }}
                onClick={() => changeSample(index)}
              >
                <div className="gravity_center img_sample_docs">
                  <img src={item.sample_img} alt={item.sample_name} />
                </div>
              </div>
              <div className="gravity_center">{item.sample_name}</div>
            </div>
          ))}
        </div>

        {/* Color Options */}
        <h5 className="margin_10">Color Option</h5>
        <div className="row bg_card_grey_outline">
          {mColorOption.map((item, index) => {
            const [color1, color2] = item.sample_color_code.split("_");
            return (
              <div
                className="col-sm-1 padding_0 height_match_parent"
                key={index}
              >
                <div
                  className={
                    SELECTED_COLOR_POSITION === index
                      ? "bg_card_green_outline cursor"
                      : "bg_card_grey_outline cursor"
                  }
                  style={{
                    padding: "3px",
                    color: "#fff",
                    margin: "2px",
                    height: "50px",
                  }}
                  onClick={() => changeColor(index)}
                >
                  <div className="gravity_center_row">
                    <div
                      style={{
                        backgroundColor: color1,
                        height: "40px",
                        width: "50%",
                      }}
                    ></div>
                    <div
                      style={{
                        backgroundColor: color2,
                        height: "40px",
                        width: "50%",
                      }}
                    ></div>
                  </div>
                </div>
                <div className="content_center">{item.sample_color_name}</div>
              </div>
            );
          })}
        </div>

        {/* Preview */}
        <h5 className="margin_10">Preview</h5>
        <div className="row margin_10">
          {showPreview && (
            <div>
              <MyLoader />
            </div>
          )}
          <Iframe
            ref={iframeRef}
            src={FILE_URL}
            width="100%"
            height={height}
            style={{ border: "none", overflow: "hidden" }}
            id="iFrame1"
            scrolling="no"
            onLoad={() => setShowPreview(false)}
          />
        </div>

        {isOpenSelectStaff && (
          <MdlSelectMultipleStaff
            actionClose={() => setIsOpenSelectStaff(false)}
            actionHandleSelected={HandleSelectedStaff}
          />
        )}

        {isOpenSettings && (
          <MdlStaffIdCardSettings
            sample_id={SELECTED_SAMPLE_ID}
            color_option_id={COLOR_OPTION_ID}
            actionClose={() => setIsOpenSettings(false)}
            actionDone={() => HandleDone()}
            file_url={PreviewURL}
          />
        )}
      </div>
    </div>
  );
};

export default PrintableDocsStaffId;
